export default "__VITE_PUBLIC_ASSET__c083d779__"